import { UserWorkoutSession } from 'fitbeat.gym-core';
import { CardioOrResistance } from 'fitbeat.models';
import moment from 'moment-timezone';
import React from 'react';
import { StyleSheet } from 'react-native';
import BalanceIcon from '../../assets/images/balance-white.svg';
import BuildIcon from '../../assets/images/icon-build-white.svg';
import BurnIcon from '../../assets/images/icon-burn-white.svg';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import { getTimezoneFromGymName } from '../../utils/gyms';

export const plannerStyles = StyleSheet.create({
  plannerEntry: {
    borderRadius: 5,
    flexDirection: 'row',
    minHeight: defaultScale(60),
    paddingVertical: defaultScale(10),
    marginRight: defaultScale(3),
    marginLeft: defaultScale(15),
    padding: defaultScale(10),
  },
  confirmedEntry: {
    backgroundColor: Theme.DARK_CHARCOAL,
  },
  unConfirmedEntry: {
    backgroundColor: Theme.WHITE,
    borderWidth: defaultScale(1),
    borderColor: Theme.DARK_CHARCOAL,
  },
  firstCard: {},
  secondCardOnwards: {
    marginTop: defaultScale(5),
  },
});

export const avatarSize = defaultScale(45);

const iconSize = defaultScale(30);

export const iconsMapLight = {
  [CardioOrResistance.Cardio]: <BurnIcon fill={Theme.WHITE} height={iconSize} width={iconSize} />,
  [CardioOrResistance.Resistance]: <BuildIcon fill={Theme.WHITE} height={iconSize} width={iconSize} />,
  [CardioOrResistance.Balance]: <BalanceIcon color={Theme.WHITE} height={iconSize} width={iconSize} strokeWidth={2} />,
};

export const iconsMapDark = {
  [CardioOrResistance.Cardio]: <BurnIcon fill={Theme.GREY_DARK} height={iconSize} width={iconSize} />,
  [CardioOrResistance.Resistance]: <BuildIcon fill={Theme.GREY_DARK} height={iconSize} width={iconSize} />,
  [CardioOrResistance.Balance]: <BalanceIcon
    color={Theme.GREY_DARK} height={iconSize} width={iconSize} strokeWidth={2} />,
};

export function getBookingTime(workoutSession: UserWorkoutSession): string {
  return moment.tz(
    workoutSession.startTimeOfFirstExercise,
    getTimezoneFromGymName(workoutSession.gymName)).format('HH:mm');
}
